module.exports = __webpack_public_path__ + "img/banner2_9_kr.d6d00620.png";